<script>
export default {
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      headers: [
        {
          align: 'start',
          sortable: false,
          value: 'checked'
        },
        {
          align: 'start',
          value: 'name',
          sortable: false
        }
      ]
    }
  },
  created() {
  }
}
</script>
<template>
  <v-card dense flat>
    <v-card-subtitle class="pl-0 pb-0"
    ><strong><slot></slot></strong
    ></v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text class="pl-0">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        hide-default-header
        hide-default-footer
        class="elevation-0">
        <template #no-data>
          {{ $t('global.no.entries') }}
        </template>
        <template #header>
          <thead>
          <tr>
            <th style="height: 0px; width: 50px; border-bottom: 0px"></th>
          </tr>
          </thead>
        </template>
        <template #[`item.checked`]="{ item }">
          <slot name="item" :credential="item"> </slot>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
